import { AfterViewInit, Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { ModalConfig, RouteRenderModalService } from '../../../shared/services/route-render-modal.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { DeviceTypeDirective } from '@laasy/common-layout';

@Component({
  selector: 'app-route-render-modal',
  templateUrl: './route-render-modal.component.html',
  animations: [
    trigger('modalAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'scale(0.95)' }))
      ])
    ])
  ],
  styleUrls: ['./route-render-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, DialogModule, RouterModule,DeviceTypeDirective]
})
export class RouteRenderModalComponent implements OnInit,AfterViewInit {
  @Input() visible: boolean = true;
  @Input() header: string = '';
  @Input() width: string = '50vw';
  @Input() dismissableMask: boolean = true;
  @Input() closable: boolean = true;
  @Input() styleClass: string = '';
  @ViewChild('dialogRef', { read: ElementRef }) dialogElement!: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private routeRenderModalService: RouteRenderModalService
  ) {}

  ngOnInit() {
    // Get configuration from router state if available
    const navigation = this.router.getCurrentNavigation();
    const config = navigation?.extras?.state?.['modalConfig'] as ModalConfig;

    if (config) {
      this.header = config.header;
      this.width = config.width || this.width;
      this.dismissableMask = config.dismissableMask ?? this.dismissableMask;
      this.closable = config.closable ?? this.closable;
      this.styleClass = config.styleClass || this.styleClass;
    }

    // Get configuration from route data if available
    const routeData = this.route.snapshot.data as Partial<ModalConfig>;
    if (routeData) {
      this.header = routeData.header || this.header;
      this.width = routeData.width || this.width;
      this.dismissableMask = routeData.dismissableMask ?? this.dismissableMask;
      this.closable = routeData.closable ?? this.closable;
      this.styleClass = routeData.styleClass || this.styleClass;
    }
  }

  ngAfterViewInit(): void {
    this.routeRenderModalService.setDialogRef(this);
  }

  close() {
    this.visible = false;
    this.router.navigate([{ outlets: { modal: null } }]);
  }
}
